import { Layout } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';
import { ViewModes } from 'types/ViewModes';

import DesktopLayout from './components/Layouts/DesktopLayout/DesktopLayout';
import MobileLayout from './components/Layouts/MobileLayout/MobileLayout';
import MainContent from './components/MainContent';

const RootContainer = styled.div`
  height: 100%;
`;

const Container = styled(Layout)`
  /* margin: 20px; */
  height: 100%;
  width: 100%;
  p {
    margin-top: 10px;
  }
`;

function App() {
  const store_ui = store.ui;

  switch (store_ui.viewMode) {
    case ViewModes.NONE:
      return <div />;

    case ViewModes.FRAMELESS:
      return <MainContent />;

    default:
      return (
        <RootContainer>
          <Container>
            {store_ui.isMobile ? <MobileLayout /> : <DesktopLayout />}
          </Container>
        </RootContainer>
      );
  }
}

export default observer(App);
